import { AlertTriangle, ShieldQuestion } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/atoms/Button";
import { Dialog } from "./Dialog";

export type ConfirmDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  /** Shown on the confirm button while `onConfirm` runs. */
  busyLabel?: string;
  tone?: "default" | "danger";
  busy?: boolean;
  onConfirm: () => void;
};

/** Confirmation step for destructive or irreversible actions. */
export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel, busyLabel, tone = "default", busy, onConfirm }: ConfirmDialogProps) {
  const { t } = useTranslation();
  const Icon = tone === "danger" ? AlertTriangle : ShieldQuestion;
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      dismissible={!busy}
      title={
        <span className="flex items-center gap-3">
          <span className={tone === "danger" ? "grid h-9 w-9 place-items-center rounded-xl bg-destructive-soft text-destructive" : "grid h-9 w-9 place-items-center rounded-xl bg-primary-soft text-primary"}>
            <Icon className="h-5 w-5" aria-hidden />
          </span>
          {title}
        </span>
      }
      description={description}
      footer={
        <>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy}>
            {t("common.cancel")}
          </Button>
          <Button variant={tone === "danger" ? "danger" : "primary"} onClick={onConfirm} loading={busy} loadingText={busyLabel}>
            {confirmLabel}
          </Button>
        </>
      }
    />
  );
}
